module.exports = __webpack_public_path__ + "img/registration_img.37535a28.png";